<template>
  <fieldset class="mt-4 flex flex-col space-y-2" id="role_selector">
    <label
      :class="[
        'flex cursor-pointer items-center space-x-4 rounded-md border px-4 py-2 hover:bg-neutral-50',
        role.id === modelValue ? 'border-primary-500' : 'border-neutral-500',
      ]"
      :for="role.id"
      v-for="role in roles"
      :modelValue="modelValue"
      @update:modelValue="modelValue = $event"
    >
      <input
        type="radio"
        :id="role.id"
        name="role"
        class="block h-4 w-4 border border-2 border-neutral-500"
        :checked="role.id === modelValue"
        @change="updateValue(role.id)"
      />
      <div>
        <TH2 class="text-neutral-950">{{ role.name }}</TH2>
        <TP2 class="-mt-1 text-neutral-500">{{ role.description }}</TP2>
      </div>
    </label>
  </fieldset>
</template>
<script lang="ts" setup>
import { CourseMembershipRole } from '~/graphql';

const { $t } = useNuxtApp();

const props = defineProps<{
  modelValue?: CourseMembershipRole | 'TEACHER';
}>();

const emits = defineEmits(['update:modelValue']);

const roles = ref([
  {
    id: 'TEACHER',
    name: $t('course_settings.collaboration.role.teacher'),
    description: $t('course_settings.collaboration.role.teacher_description'),
  },
  {
    id: 'CO_TEACHER',
    name: $t('course_settings.collaboration.role.co_teacher'),
    description: $t(
      'course_settings.collaboration.role.co_teacher_description',
    ),
  },
  {
    id: 'GUEST',
    name: $t('course_settings.collaboration.role.guest'),
    description: $t('course_settings.collaboration.role.guest_description'),
  },
]);

function updateValue(value: CourseMembershipRole) {
  emits('update:modelValue', value);
}
</script>
